import routes from "@/routers/routes";
import PageHeader from "@/app/shared/page-header";
import ExportButton from "@/app/shared/export-button";
import { Button } from "rizzui";
import { Link } from "react-router-dom";
import { PiPlusBold } from "react-icons/pi";

interface HeaderProps {
    title: string;
    hideButton: boolean;
}

export default function ServicePageHeader({ title, hideButton }: HeaderProps) {
    const pageHeader = {
        title: title,
        breadcrumb: [
            {
                href: "/",
                name: "Home",
            },
            {
                href: routes.settings.general.list,
                name: "Service",
            },
        ],
    };
    return (
        <PageHeader title={pageHeader.title} breadcrumb={pageHeader.breadcrumb}>
            {hideButton == false ? (
                <Link
                    to={routes.settings.services.create}
                    className="w-full @lg:w-auto"
                >
                    <Button as="span" className="w-full @lg:w-auto">
                        <PiPlusBold className="me-1.5 h-[17px] w-[17px]" />
                        Add New Service
                    </Button>
                </Link>
            ) : (
                <></>
            )}
        </PageHeader>
    );
}
